import EventList from "./EventList";
function Events (){
    return <div className='home'>
        <EventList/>
    </div>
    
}

export default Events;